import { render, staticRenderFns } from "./UiAccordion.vue?vue&type=template&id=49199b40&"
import script from "./UiAccordion.vue?vue&type=script&lang=js&"
export * from "./UiAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports